import styled from 'styled-components'

const Aside = styled.aside`
  background: ${({ className }) =>
    className.includes('warning')
      ? '#c97a7e'
      : className.includes('success')
      ? '#6ac174'
      : 'rgb(143, 188, 212)'};
  padding: 1em 28px;
  margin-top: 1.5em;
  margin-bottom: 1.5em;
  line-height: 1.6;
  box-sizing: border-box;
  display: block;
  &.customtext {
    &:after {
         content: " Support for this API will no longer be available after October 2020."
       };
    margin-top: 0;
    margin-bottom: 0;
    color: #a94442;
    background-color: #f2dede;
    border-color: #ebccd1;
  }
`;
export default Aside
